var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KioskAuthLayout",
    {
      attrs: {
        "show-next-button": false,
        "is-new": true,
        "show-back-button": "",
        title: "Save Past Orders"
      },
      on: { back: _vm.handleBack }
    },
    [
      _c("ul", { class: _vm.$style.advantagesList }, [
        _c("li", { class: _vm.$style.advantagesListItem }, [
          _c("div", { class: _vm.$style.checkmark }, [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.checkmarkWhite,
              attrs: { symbol: "checkmark-icon" }
            })
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        Register a phone number at our kiosk, online, or through our mobile\n        app.\n      "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { class: _vm.$style.advantagesListItem }, [
          _c("div", { class: _vm.$style.checkmark }, [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.checkmarkWhite,
              attrs: { symbol: "checkmark-icon" }
            })
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Use this phone number when you order.")])
        ]),
        _vm._v(" "),
        _c("li", { class: _vm.$style.advantagesListItem }, [
          _c("div", { class: _vm.$style.checkmark }, [
            _c("svg", {
              directives: [{ name: "svg", rawName: "v-svg" }],
              class: _vm.$style.checkmarkWhite,
              attrs: { symbol: "checkmark-icon" }
            })
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Re-order up to 5 of your past orders, quickly and easily!")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$style.advBlock }, [
        _c("h2", [_vm._v("Order Online!")]),
        _vm._v(" "),
        _c("p", [_vm._v("Burger Boss mobile apps now available")]),
        _vm._v(" "),
        _c("div", { class: _vm.$style.appsButtons }, [
          _c("a", { attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/app_store.png"),
                alt: "Download on the AppStore"
              }
            })
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: require("@/assets/img/google_play.png"),
                alt: "Get it on Google Play"
              }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/PastOrdersInfo.vue?vue&type=template&id=42da3c98&
// module id = null
// module chunks = 